'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBriefcase = function FaBriefcase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.3 5.7h11.4v-2.8h-11.4v2.8z m25.7 14.3v10.7q0 1.5-1 2.5t-2.6 1.1h-32.8q-1.5 0-2.6-1.1t-1-2.5v-10.7h15v3.6q0 0.5 0.4 1t1 0.4h7.2q0.6 0 1-0.4t0.4-1v-3.6h15z m-17.1 0v2.9h-5.8v-2.9h5.8z m17.1-10.7v8.6h-40v-8.6q0-1.5 1.1-2.5t2.5-1.1h7.8v-3.6q0-0.8 0.7-1.5t1.5-0.6h12.8q0.9 0 1.5 0.6t0.7 1.5v3.6h7.8q1.5 0 2.6 1.1t1 2.5z' })
        )
    );
};

exports.default = FaBriefcase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/briefcase.js
// module id = 600
// module chunks = 168707334958949